// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-item.active > .nav-link {
    color: #F2721E !important; 
    background-color: transparent;}

.nav-dropdown.open > .nav-link {
    color: #F2721E !important;
    font-weight: bold; 
    background-color: transparent;
}

.nav-item.active > .nav-link:hover {
    color: white !important; 
    background-color: #F2721E !important;
    border-radius: 4px; 
}

.nav-dropdown.open > .nav-link:hover {
    color: white !important;
    background-color: #F2721E !important; 
    border-radius: 4px;
}

.nav-dropdown-items .nav-item > .nav-link:hover {
    color: white !important; 
    background-color: #F2721E !important;
    border-radius: 4px;
}

/* Sidebar hiển thị khi isSidebarVisible là true */
.sidebar.visible {
    display: block;
    transform: translateX(0);
}

/* Đảm bảo sidebar chỉ hiển thị trên màn hình nhỏ */
@media (max-width: 768px) {
    .sidebar {
        display: none; /* Ẩn sidebar mặc định */
    }

    .sidebar.visible {
        display: block; /* Hiển thị sidebar khi mở */
    }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,6BAA6B,CAAC;;AAElC;IACI,yBAAyB;IACzB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA,kDAAkD;AAClD;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA,mDAAmD;AACnD;IACI;QACI,aAAa,EAAE,wBAAwB;IAC3C;;IAEA;QACI,cAAc,EAAE,4BAA4B;IAChD;AACJ","sourcesContent":[".nav-item.active > .nav-link {\n    color: #F2721E !important; \n    background-color: transparent;}\n\n.nav-dropdown.open > .nav-link {\n    color: #F2721E !important;\n    font-weight: bold; \n    background-color: transparent;\n}\n\n.nav-item.active > .nav-link:hover {\n    color: white !important; \n    background-color: #F2721E !important;\n    border-radius: 4px; \n}\n\n.nav-dropdown.open > .nav-link:hover {\n    color: white !important;\n    background-color: #F2721E !important; \n    border-radius: 4px;\n}\n\n.nav-dropdown-items .nav-item > .nav-link:hover {\n    color: white !important; \n    background-color: #F2721E !important;\n    border-radius: 4px;\n}\n\n/* Sidebar hiển thị khi isSidebarVisible là true */\n.sidebar.visible {\n    display: block;\n    transform: translateX(0);\n}\n\n/* Đảm bảo sidebar chỉ hiển thị trên màn hình nhỏ */\n@media (max-width: 768px) {\n    .sidebar {\n        display: none; /* Ẩn sidebar mặc định */\n    }\n\n    .sidebar.visible {\n        display: block; /* Hiển thị sidebar khi mở */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
